var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "central about" },
    [
      _c("main-content-container", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "items-list" },
                  [
                    _c(
                      "list-item",
                      {
                        attrs: {
                          title: _vm.$t("mainPage.appname"),
                          noHover: true,
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "logo left-slot",
                          attrs: { slot: "media", src: _vm.logoImg },
                          slot: "media",
                        }),
                      ]
                    ),
                    _c(
                      "list-item",
                      {
                        staticClass: "version",
                        attrs: {
                          header: _vm.versionHeaderText,
                          title: _vm.$t("mainPage.version") + _vm.version,
                          noHover: true,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "left-slot",
                            attrs: { slot: "media" },
                            slot: "media",
                          },
                          [
                            _c("i", {
                              staticClass: "status-icon",
                              class: _vm.versionIconClasses,
                            }),
                          ]
                        ),
                      ]
                    ),
                    [
                      _vm.newClientInfo
                        ? _c(
                            "div",
                            [
                              _c(
                                "list-item",
                                {
                                  staticClass: "new-version-header",
                                  attrs: {
                                    header: _vm.$t("mainPage.new-version"),
                                    title:
                                      _vm.$t("mainPage.version") +
                                      _vm.newClientInfo.version,
                                    noHover: true,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "left-slot",
                                      attrs: { slot: "media" },
                                      slot: "media",
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "update-icon far fa-sync-alt",
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "footer-link",
                                      attrs: { slot: "footer-link" },
                                      slot: "footer-link",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "new-version-install",
                                          class: { disabled: _vm.updating },
                                          attrs: { title: _vm.buttonText },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "link",
                                              on: { click: _vm.updateClient },
                                            },
                                            [_vm._v(_vm._s(_vm.buttonText))]
                                          ),
                                          _vm.buttonFooterText
                                            ? _c(
                                                "span",
                                                { staticClass: "footerText" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.buttonFooterText)
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "list-item",
                        {
                          staticClass: "new-version-changes history",
                          attrs: {
                            header: _vm.$t("mainPage.whats-new"),
                            title: _vm.newClientInfo
                              ? _vm.newClientInfo.changes
                              : _vm.lastVersionChange,
                            noHover: true,
                          },
                        },
                        [
                          _c("div", {
                            staticClass: "left-slot",
                            attrs: { slot: "media" },
                            slot: "media",
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "footer-link",
                              attrs: { slot: "footer-link" },
                              slot: "footer-link",
                            },
                            [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.openChanges()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("settings.versions-history"))
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                  ],
                  2
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("main-content-container", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "items-list" },
                  [
                    _c("list-item", {
                      attrs: {
                        title: _vm.$t("loginPage.developer"),
                        footer: "2014-" + _vm.this_year,
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }